import { nanoid } from "nanoid";

export const validateTravelDataInput = (params) => {
  const validationRules = {
    hotelCodes: {
      required: true,
      alternateNames: ["destination_raw", "location", "destination"],
    },
    arrivalDate: {
      required: true,
      alternateNames: ["startdate"],
    },
    departureDate: {
      required: true,
      alternateNames: ["enddate"],
    },
    guestsPerRoom: {
      required: true,
      alternateNames: ["count_guests", "totalGuests"],
      default: 1,
    },
    numberOfRooms: {
      required: true,
      alternateNames: ["count_rooms"],
      default: 1,
    },
    promoCode: {
      required: false,
      alternateNames: [],
    },
  };

  const validatedParams = {};
  let dataValid = true;

  for (const key in validationRules) {
    const rule = validationRules[key];
    let value = params[key] || null;
    if (!value && rule.alternateNames) {
      rule.alternateNames.forEach((alt) => {
        value = params[alt] ?? value;
      });
    }
    if (
      value &&
      ((key === "guestsPerRoom" && typeof value === "string") ||
        (key === "numberOfRooms" && typeof value === "string"))
    ) {
      value = parseInt(value, 10);
    }

    if (!value && rule.default) {
      value = rule.default;
    }
    if (!rule.required || (rule.required && value)) {
      validatedParams[key] = value;
    } else {
      dataValid = false;
      break;
    }
  }

  if (Object.keys(validatedParams).length > 0 && dataValid) {
    return validatedParams;
  } else {
    throw new Error("Please provide all required parameters");
  }
};

export const cfLocation = (locale) => {
  switch (locale) {
    case "zh":
    case "cn":
      return "zh-Hant";
    case "it":
      return "it-IT";
    case "es":
      return "es-US";
    default:
      return locale;
  }
};

export const generateRandomHexString = (length) => {
  return nanoid(length).toLowerCase().replaceAll("_", "-");
};
